(() => {
  function initialize(root) {
    if (root.dataset.tocReady) return;
    root.dataset.tocReady = 'true';
    const content = root.querySelector('[data-sy-article-content]');
    const sidebar = root.querySelector('[data-sy-article-toc]');
    if (!content || !sidebar) return;
    const narrow = window.matchMedia('(max-width: 989px)');
    const toggle = sidebar.querySelector('[data-sy-article-toc-toggle]');
    const navigation = sidebar.querySelector('nav');
    const count = sidebar.querySelector('[data-sy-article-toc-count]');
    const header = document.querySelector('[data-suityou-header]');
    const headerContainer = header?.closest('.shopify-section') || header;
    let mobileOffset = 120;
    const syncHeaderOffset = () => {
      mobileOffset = headerContainer ? Math.ceil(headerContainer.getBoundingClientRect().height) + 16 : 120;
      if (narrow.matches) root.style.setProperty('--sy-mobile-article-scroll-offset', `${mobileOffset}px`);
    };
    const setExpanded = (expanded) => {
      if (toggle) toggle.setAttribute('aria-expanded', String(expanded));
      if (navigation) navigation.hidden = narrow.matches && !expanded;
    };
    const syncPresentation = () => {
      setExpanded(false);
      syncHeaderOffset();
    };
    const selector = sidebar.dataset.includeH3 === 'true' ? 'h2, h3' : 'h2';
    const headings = [...content.querySelectorAll(selector)].filter(node => node.textContent.trim());
    if (!headings.length) {
      sidebar.dataset.tocEmpty = 'true';
      return;
    }
    const entries = [];
    const first = content.firstElementChild;
    if (first && first !== headings[0] && !/^H[23]$/.test(first.tagName)) {
      entries.push({ node: first, label: 'Introduction', subheading: false });
      first.setAttribute('data-article-introduction', '');
    }
    for (const heading of headings) {
      entries.push({ node: heading, label: heading.textContent.trim(), subheading: heading.tagName === 'H3' });
    }
    const list = sidebar.querySelector('[data-sy-article-toc-list]');
    const links = [];
    list.replaceChildren();
    for (const [index, entry] of entries.entries()) {
      if (!entry.node.id || document.getElementById(entry.node.id) !== entry.node) {
        const slug = entry.label.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'section';
        let id = `${root.id}-${slug}`;
        let suffix = 2;
        while (document.getElementById(id)) id = `${root.id}-${slug}-${suffix++}`;
        entry.node.id = id;
      }
      const item = document.createElement('li');
      if (entry.subheading) item.className = 'is-subheading';
      const link = document.createElement('a');
      link.href = `#${entry.node.id}`;
      link.textContent = entry.label;
      link.addEventListener('click', (event) => {
        event.preventDefault();
        if (narrow.matches) {
          setExpanded(false);
          syncHeaderOffset();
        }
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        entry.node.scrollIntoView({ behavior: reduced ? 'instant' : 'smooth', block: 'start' });
        history.replaceState(null, '', link.hash);
        entry.node.setAttribute('tabindex', '-1');
        entry.node.focus({ preventScroll: true });
        activate(index);
      });
      item.append(link);
      list.append(item);
      links.push(link);
    }
    function activate(index) {
      links.forEach((link, i) => {
        if (i === index) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
    }
    if (count) count.textContent = `${entries.length} ${entries.length === 1 ? 'section' : 'sections'}`;
    const onToggle = () => setExpanded(toggle.getAttribute('aria-expanded') !== 'true');
    toggle?.addEventListener('click', onToggle);
    narrow.addEventListener('change', syncPresentation);
    syncPresentation();
    const headerObserver = headerContainer && 'ResizeObserver' in window ? new ResizeObserver(syncHeaderOffset) : null;
    headerObserver?.observe(headerContainer);
    let frame = 0;
    const update = () => {
      frame = 0;
      let active = 0;
      for (const [index, entry] of entries.entries()) {
        if (entry.node.getBoundingClientRect().top <= (narrow.matches ? mobileOffset + 48 : 170)) active = index;
        else break;
      }
      activate(active);
    };
    const onScroll = () => { if (!frame) frame = requestAnimationFrame(update); };
    window.addEventListener('scroll', onScroll, { passive: true });
    const onResize = () => { syncHeaderOffset(); onScroll(); };
    window.addEventListener('resize', onResize);
    // Theme editor section reloads must not accumulate scroll listeners.
    const unload = (event) => {
      if (!event.target.contains(root)) return;
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onResize);
      narrow.removeEventListener('change', syncPresentation);
      toggle?.removeEventListener('click', onToggle);
      headerObserver?.disconnect();
      if (frame) cancelAnimationFrame(frame);
      document.removeEventListener('shopify:section:unload', unload);
    };
    document.addEventListener('shopify:section:unload', unload);
    sidebar.hidden = false;
    update();
  }
  const initializeAll = (scope) => scope.querySelectorAll('[data-sy-article-reading]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll(document), { once: true });
  else initializeAll(document);
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
